import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Chunked upload to bypass proxy body-size limits. Returns an absolute file URL.
export async function uploadFileChunked(file, onProgress) {
  const CHUNK = 512 * 1024;
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const uploadId = `${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  let last = null;
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * CHUNK, (i + 1) * CHUNK);
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", String(i));
    fd.append("total_chunks", String(total));
    fd.append("filename", file.name);
    fd.append("content_type", file.type || "application/octet-stream");
    fd.append("chunk", blob, file.name);
    const { data } = await api.post("/seller/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    last = data;
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  if (!last || last.status !== "complete") throw new Error("Upload incomplet");
  return `${BACKEND_URL}${last.url}`;
}

export default api;
